export default __webpack_public_path__ + "static/media/sidebar3.3d15527f.jpg";